import React from "react";
import './../styles/CriterionSearch.css';
import SingularCriterion from "./SingularCriterion";
const CriterionSearch = function (props) {
    return React.createElement("div", { className: "criterionSearch" }, props.visibleFeaturesSets.map((featureSet, index) => React.createElement(SingularCriterion, { key: index, stateToChangeChosenFeatures: props.setChosenFeatures, criterionName: featureSet.name, features: featureSet.settableOptions, setFeature: featureSet.setFeatures })));
};
export default CriterionSearch;
